
export interface IJobNameAction {
    type: string,
    payload?: IJobName
}

export interface IJobName {
    [key: string]: string;
}

const jobnameDefault: IJobName = {}

function jobnameReducer(state: IJobName = jobnameDefault, action: IJobNameAction): IJobName {
    switch (action.type) {
        case "JOBNAME_UPDATE":
            return Object.assign({}, action.payload);
        case "JOBNAME_ADD":
            return Object.assign({}, state, action.payload);
        case "JOBNAME_CLEAR":
            return {};
        case "SIGN_OUT":
            return {};
        case "UPDATE_PROJECT":
            return {};
        case "CLEAR_PROGRESS":
            return {};
        case "PROGRESS_CLEAR":
            return jobnameDefault;
        default:
            return state;
    }
}


export default jobnameReducer;